module.exports = __webpack_public_path__ + "static/img/epmTitle.9f3c14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epmTitle.png
// module id = xl07
// module chunks = 6